var ARDivider = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    "ar-divider",
    _vm.type !== 'default' && _vm.type
  ],attrs:{"ar-widget-id":"ar-divider","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-divider"}})},
staticRenderFns: [],
  name: 'ARDivider',
  props: {
    arWidgetMeta: String,
    type: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'soft'].indexOf(val) > -1,
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [].join('');
    },
  },
};

export default ARDivider;
